import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import dayjs from "dayjs";
import ShowPaginationData from "../../components/UI/TableView/ShowPaginationData";
import { IoAdd } from "react-icons/io5";


export default function NutritionItemSells() {
  // console.log('first')
  const { columns, id, label, url, href } = {
    id: 'nutrition-sales', label: 'nutritionSales',
    href: '/nutrition-sales',
    columns: [{ label: '#', value: a => a._id },
    { label: 'name', sort: 'name', classnames: () => 'font-[Montserrat]', value: (a) => a.name },
    { label: 'trainer', classnames: () => 'font-[Montserrat]', value: (a) => a.trainer && a.trainer[0] ? a.trainer[0].name : 'H&H Gym' },
    { label: 'price', sort: 'price', value: (a) => showInIQD(a.price, 'USD') + ' - ' + showInIQD(a.iqd) },
    { label: 'date', sort: 'createdAt', value: (a) => dayjs(a.createdAt).format('YYYY-MM-DD HH:mm') },
    ],
    url: (centerId) => `/nutrition-sales?startDate=${dayjs().format('YYYY-MM-DD')}&endDate=${dayjs().format('YYYY-MM-DD')}&` + centerId,
  }
  const history = useHistory()

  const [requestModal, setRequestModal] = useState(false)
  const [currentOrder, setCurrentOrder] = useState(false)

  const onPressCreateUser = () => {
    history.push(window.location.pathname + '/add-nutrition')
  }
  const sendRequest = (data) => {
    setCurrentOrder(data)
    setRequestModal(!requestModal)
  }

  return (
    <div className="flex flex-col items-center w-full bg-white">
      {/* {requestModal && <RequestModal data={currentOrder} requestType={2} toggleModal={sendRequest} />} */}

      <ShowPaginationData defaultSort={[{ sort: 'createdAt', sortBy: 1 }]} hrefId={null} onClickItem={(_id) => sendRequest(_id)} rightButton={<div className="cursor-pointer" >
        <IoAdd size={40} onClick={onPressCreateUser} />
      </div>} columns={columns} href={href} id={id} label={label} url={url} />
    </div>
  );
}
